// extracted by mini-css-extract-plugin
var _1 = "EntitySelectMultiValue-module__container--mkonv";
export { _1 as "container" }
